import GetUserModel from './models/GetUserModel';
import EditUserModel from './models/EditUserModel';
import AddUserModel from './models/AddUserModel';

const AddAdminStore = {
  name: 'AddAdminStore',
  spec: AddUserModel,
  saveLocally: false,
  initialState: {
    res: "Oops...Something went wrong. Please try again.",
    stat: ""
  }
};
const GetUserStore = {
  name: 'GetUserStore',
  spec: GetUserModel,
  saveLocally: false,
  initialState: {
    id: '',
    name: '',
    status: '',
    isAdmin: false,
    startDate: '',
    endDate: '',
    email: ''
  }
};
const EditUserStore = {
  name: 'EditUserStore',
  spec: EditUserModel,
  saveLocally: false,
  initialState: {
    res: "Oops...Something went wrong. Please try again.",
    stat: ""
  },
};

const stores = [AddAdminStore, GetUserStore, EditUserStore]

export default stores;